module.exports = __webpack_public_path__ + "static/visual_6_2_do-a19756a85c70551b6ae7179fa6672a76.png";